<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0 mt-2">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <h4 style="color: #000; text-align: left" class="custom-user-grade">
              <b>Salary History Details</b>
            </h4>
            <div class="ml-4 mt-4">
              <div
                v-for="item in salarys.teacherSalaryDetail"
                v-bind:key="item.Id"
              >
                  <div style="width: 80%" class="float-left">
                    <h3 class="custom-label-muted text-uppercase">
                      {{ item.CreatedTime | moment("DD MMMM") }}
                    </h3>
                    <h4 class="custom-label-muted">
                      <strong>{{ item.SubjectName }}</strong>
                    </h4>
                    <h5 class="custom-label-muted">
                      {{ item.StartTime | moment("hh:mm A") }} -
                      {{ item.EndTime | moment("hh:mm A") }}
                    </h5>
                  </div>
                  <div style="width: 20%" class="float-right">
                    <h5 class="text-success-amount">
                      + RM {{ item.TotalPayment }}
                    </h5>
                  </div>
                  <div style="clear: both"></div>
                  <hr />
                </div>
               
            </div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="header-top">{{ Month }}</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>

    <div style="clear: both"></div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
} from "hooper";

import MainlayoutBottom from "../../containers/TheBottomCustom.vue";

Vue.use(require("vue-moment"));
import moment from "moment";

import "hooper/dist/hooper.css";

export default {
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
    MainlayoutBottom,
  },
  data: function () {
    return {
      user: {},
      studentProfileAuthorize: "",
      childs: [],
      salarys: {},
      Month: this.$route.query.month,
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
    TotalAmounts: {
      get: function () {
        var total = 0;

        for (let i = 0; i < this.salarys.teacherSalaryDetail.length; i++) {
          total += this.salarys.teacherSalaryDetail[i].TotalPayment;
        }
        console.log("salary" + total);
        return total;
      },
    },
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetAuthorizeProfile(this.user.id);
            this.GetTeacherSalary(this.user.id);
          }
        });
    },
    GetAuthorizeProfile() {
      this.$API
        .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfileAuthorize;
          }
        });
    },
    GetTeacherSalary() {
      this.$API
        .get(
          this.$TeacherSalaryDetail +
            "?userId=" +
            this.user.id +
            "&monthName=" +
            this.$route.query.month,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.salarys = response.data;
          }
        });
    },
    GoToRegisterStudent() {
      this.$router.push("/RegisterStudent");
    },
    GoBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: auto;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

.progress {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.65625rem;
  border-radius: 0.25rem;
  background-color: #ebedef;
  height: 15px;
  border-radius: 10px;
}
</style>